// @flow

import React from 'react'
import L from 'leaflet';
import { Map, TileLayer, FeatureGroup, Pane, Circle } from 'react-leaflet'

import Control from './Control'

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});


class DigitMap extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      ...props,
      mapConfiguration: {
        center: [0, 0],
        zoom: 19,
        maxZoom: 19,
        minZoom: 17,
        zoomControl: false,
        scrollWheelZoom: false,
        useFlyTo: false,
        doubleClickZoom: false, 
        style: {
          height: "800px",
        }
      },
      userLocation: [0, 0],
      hasLocation: false,
      child: React.createRef()
    }

  }


  componentDidMount() {

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        this.setState(prevState => ({
          userLocation: [latitude, longitude],
          hasLocation: true,
          mapConfiguration: {
            ...prevState.mapConfiguration,
            //center: [43.2949898, 5.3863683]
          }
        }));
      },
      (error) => this.setState({ error: error.message }),
      {
        enableHighAccuracy: true,
        timeout: 2000,
        maximumAge: 1000
      },
    );
  }

  resetSelection = () => {
    this.state.child.current._reset();
  }

  render() {

    const { mapConfiguration, userLocation, hasLocation } = this.state

    return (
      <Map {...mapConfiguration} onClick={this.resetSelection}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; <a href=&quot;https://www.pilotparc.com&quot;>Digit'Marché</a>"
        />

        <Control ref={this.state.child} jmid={this.props.jmid} layersGroup={this.props.layersGroup} />

      </Map>
    )

  }

}

export default DigitMap;
